import { Routes, Route } from 'react-router-dom'

import Home from './pages/Home'
import Construindo from './pages/Construindo'
import TrabalheConosco from './pages/TrabalheConosco'
import TurmaDetalhes from './pages/TurmaDetalhes'
import AdminLogin from './pages/AdminLogin'
import AdminArea from './pages/AdminArea'
import AdminCarousel from './pages/AdminCarousel'
import AdminAvisos from './pages/AdminAvisos'
import AdminSobre from './pages/AdminSobre'
import AdminTurmas from './pages/AdminTurmas'
import AdminContato from './pages/AdminContato'
import AdminTrabalhe from './pages/AdminTrabalhe'
import AdminCandidatos from './pages/AdminCandidatos'
import RequireAuth from './components/RequireAuth'

const Rotas = () => (
  <Routes>
    <Route path="/" element={<Construindo />} />
    <Route path="/dev" element={<Home />} />
    <Route path="/vagas" element={<TrabalheConosco />} />
    <Route path="/turma/:id" element={<TurmaDetalhes />} />
    <Route path="/admin" element={<AdminLogin />} />
    <Route element={<RequireAuth />}>
      <Route path="/admin/dashboard" element={<AdminArea />} />
      <Route path="/admin/dashboard/carousel" element={<AdminCarousel />} />
      <Route path="/admin/dashboard/avisos" element={<AdminAvisos />} />
      <Route path="/admin/dashboard/sobre" element={<AdminSobre />} />
      <Route path="/admin/dashboard/turmas" element={<AdminTurmas />} />
      <Route path="/admin/dashboard/contato" element={<AdminContato />} />
      <Route
        path="/admin/dashboard/trabalhe-conosco"
        element={<AdminTrabalhe />}
      />
      <Route
        path="/admin/dashboard/fichas-candidatos"
        element={<AdminCandidatos />}
      />
    </Route>
  </Routes>
)

export default Rotas
